<template>
  <div class="position-relative">
    <div class="select-container" @click="showPopup" @focus="showPopup">
      <div class="selected-items" v-if="selectedItems.length">
        <span v-for="item in selectedItems" :key="item.id" class="selected-tag">
          {{ labelKey && item[labelKey] ? item[labelKey] : item.name }}
          <i class="bx bx-x" @click.stop="removeItem(item)"></i>
        </span>
      </div>
      <b-form-input
        class="border-0"
        v-else
        :value="''"
        readonly
        :size="size"
        :placeholder="placeholder"
      />
      <i
        style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%)"
        :class="isShow ? 'bx bx-caret-up' : 'bx bx-caret-down'"
      ></i>
    </div>

    <div v-show="isShow" class="popup-container">
      <div class="m-2 position-relative">
        <input
          type="text"
          ref="searchInput"
          v-model="searchText"
          class="p-1 rounded"
          placeholder="Lọc tìm kiếm"
          @input="onSearchInput"
        />
        <i
          style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%)"
          class="bx bx-search-alt-2"
        ></i>
      </div>

      <div class="list-container">
        <div
          v-for="item in filteredList"
          :key="item.id"
          class="list-item"
          @click="selectItem(item)"
          :class="{ active: value === item.id }"
        >
          {{ labelKey && item[labelKey] ? item[labelKey] : item.name }}
        </div>
        <div v-show="filteredList.length === 0" class="emtry">Không tìm thấy kết quả</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Autocomplete',

    props: {
      list: {
        type: Array,
        default: () => [],
      },
      value: {
        type: Array,
        default: () => [],
      },
      size: {
        type: String,
        default: 'sm',
      },
      placeholder: {
        type: String,
        default: 'Tìm kiếm nhân viên',
      },
      labelKey: {
        type: String,
        default: 'text',
      },
    },

    data() {
      return {
        isShow: false,
        searchText: '',
        debounceTimer: null,
        filteredList: [],
      }
    },

    computed: {
      selectedItems() {
        return this.value
      },
    },

    created() {
      document.addEventListener('click', this.handleClickOutside)
    },

    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside)
    },

    methods: {
      setFilteredList(value) {
        const selectedIds = new Set(this.value.map(v => v.id))
        this.filteredList = value.filter(item => !selectedIds.has(item.id))
      },
      showPopup() {
        this.isShow = true
        this.searchText = ''
        this.setFilteredList(this.list)
        this.$nextTick(() => this.$refs.searchInput.focus())
      },
      selectItem(item) {
        const newValue = [...this.value]
        const exists = newValue.find(v => v.id === item.id)
        if (!exists) {
          newValue.push(item)
        }
        this.$emit('input', newValue)
        this.setFilteredList(this.list)
        this.isShow = false
      },

      removeItem(item) {
        const newValue = this.value.filter(v => v.id !== item.id)
        this.$emit('input', newValue)
        this.setFilteredList(this.list)
      },

      onSearchInput() {
        clearTimeout(this.debounceTimer)
        this.debounceTimer = setTimeout(() => {
          const search = this.searchText.toLowerCase()
          const result = this.list.filter(item =>
            (item[this.labelKey] || item.name).toLowerCase().includes(search)
          )
          this.setFilteredList(result)
        }, 500)
      },

      handleClickOutside(event) {
        if (!this.$el.contains(event.target)) {
          this.isShow = false
          this.searchText = ''
        }
      },
    },
  }
</script>
<style scoped>
  .popup-container {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-top: 5px;
    z-index: 1000;
    box-shadow:
      rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
      rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  }

  .list-container {
    max-height: 150px;
    overflow-y: auto;
  }

  .list-item {
    padding: 8px 12px;
    cursor: pointer;
  }

  .emtry {
    padding: 8px 12px;
  }

  .list-item:hover {
    background-color: #2292ff;
    color: white;
  }

  .list-item.active {
    background-color: #ddd;
  }

  .select-container {
    position: relative;
    border: 1px solid #ced4da;
    border-radius: 0.2rem;
    min-height: 37px;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
  }

  .selected-items {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 2px;
  }

  .selected-tag {
    background-color: #e9ecef;
    border-radius: 4px;
    padding: 2px 8px;
    font-size: 0.875rem;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .selected-tag i {
    cursor: pointer;
    font-size: 14px;
  }

  .selected-tag i:hover {
    color: #dc3545;
  }
</style>
